<div class="relative my-4">
  <p class="font-bold text-3xl text-center pt-1">Уведомление</p>

  <div class="absolute right-0 top-0">
    <div class="border-circle hover:bg-gray-100">
      <i
        class="pi pi-times cursor-pointer p-2"
        style="font-size: 1.1rem"
        (click)="closeModal()"></i>
    </div>
  </div>
</div>

<p class="font-medium text-2xl text-center">Уважаемый клиент, Ваш бесплатный лимит рассылок исчерпан.</p>

<div class="flex justify-content-center mt-4">
  <div>
    <p class="font-medium text-2xl">Для продолжения работы Вам необходимо:</p>

    <div class="mt-3 ml-2">
      <p class="font-medium text-2xl">1. Зарегистрироваться в сервисе рассылок;</p>
      <p class="font-medium text-2xl">2. Ввести новые данные.</p>
    </div>
  </div>
</div>

<div class="flex justify-content-center align-items-center gap-4 mt-5 mb-3">
  <button
    pButton
    label="Зарегистрироваться"
    class="p-button-lg"
    style="min-width: 186px !important; max-width: 186px !important"
    (click)="linkToRegister()"></button>

  <button
    pButton
    label="Ввести данные"
    class="p-button-success p-button-lg"
    style="min-width: 186px !important; max-width: 186px !important"
    (click)="showAddModal()"></button>
</div>
